import { Avatar, Grid, ListItem, Typography } from '@mui/material';
import { IMedication, MEDICATION_STATUSES } from 'API';
import { ListDivider } from 'Components/ListDivider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleOutlineWarningIcon } from 'Images';
import { Fragment } from 'react';

interface IMedicationList {
  medications: IMedication[];
}

export const MedicationList = (props: IMedicationList) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);

  return (
    <>
      {props.medications.map((medication) => {
        const isMedicationAvailable =
          medication.OutOfStockOptionCode !== MEDICATION_STATUSES.notAvailable;

        return (
          isMedicationAvailable && (
            <Fragment key={medication.medicatioN_CODE}>
              <ListItem
                sx={{ pr: '8px', pl: '8px', height: '72px' }}
                tabIndex={0}
              >
                <Grid container gap={2} alignItems='center'>
                  <Grid item xs={12} md={4}>
                    <Typography component='h4' fontWeight={700}>
                      {medication.medicatioN_NAME}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant='body3'>
                      {dictionary.dosage(
                        medication.dosage,
                        medication.doseperday,
                        medication.fornumberdays
                      )}
                    </Typography>
                  </Grid>
                  {medication.medstatus ===
                    MEDICATION_STATUSES.notAvailable && (
                    <Grid
                      item
                      container
                      xs={12}
                      md={3}
                      alignItems='center'
                      gap={1}
                      flexWrap='nowrap'
                    >
                      <Grid item alignSelf='flex-start' mt='5px'>
                        <Avatar
                          alt={generalDictionary.info}
                          src={PurpleOutlineWarningIcon}
                          sx={{
                            width: '24px',
                            height: '24px',
                            alignSelf: 'flex-start',
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <Typography variant='body6'>
                          {medication.lackMedicineNote}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </ListItem>
              <ListDivider />
            </Fragment>
          )
        );
      })}
    </>
  );
};
